import * as PIXI from 'pixi.js';

const StripAnimation = function (stripName, duration, numFrames, loop, loopLength) {
  PIXI.Sprite.call(this);

  let START_TIME = new Date().getTime();
  let currentDuration = duration;
  let timeoutId;

  const frames = [];
  for (let i = 0; i < numFrames; ++i) {
    frames.push(PIXI.utils.TextureCache[stripName + '_' + i.toString() + '.png']);
  }
  this.texture = frames[0];

  this.anchor.x = this.anchor.y = 0.5;

  this.done = false;

  let lifeTime;
  let lifetimeRatio;
  let newFrame = 0;
  let lastFrame = 0;
  let frameId;
  const animate = () => {
    if (this.done) {
      return;
    }
    frameId = requestAnimationFrame(animate);

    lifeTime = new Date().getTime() - START_TIME;
    if (loop) {
      lifetimeRatio = (lifeTime % loopLength) / loopLength;
    } else {
      lifetimeRatio = lifeTime / currentDuration;
    }

    newFrame = Math.min(numFrames - 1, Math.floor(lifetimeRatio * numFrames));
    if (newFrame !== lastFrame) {
      this.texture = frames[newFrame];
      lastFrame = newFrame;
    }
  };
  if (duration) {
    frameId = requestAnimationFrame(animate);
  }

  this.stop = () => {
    clearTimeout(timeoutId);
    cancelAnimationFrame(frameId);
    gsap.killTweensOf(this);
    this.removeChildren();
    this.parent?.removeChild(this);
    this.done = true;
  };

  timeoutId = setTimeout(this.stop, currentDuration);

  this.reset = (newDuration) => {
    if (newDuration !== undefined) currentDuration = newDuration;
    clearTimeout(timeoutId);
    this.done = false;
    START_TIME = new Date().getTime();
    lastFrame = 0;
    frameId = requestAnimationFrame(animate);
    timeoutId = setTimeout(this.stop, currentDuration);
  };

  this.dispose = () => {
    this.stop();
    this.destroy();
  };
};
StripAnimation.prototype = Object.create(PIXI.Sprite.prototype);
StripAnimation.prototype.constructor = StripAnimation;
export default StripAnimation;
